<div class="list-container">
  <rask-list [data]="transportforetag" [getSelectedFromRoute]="true">
    <rask-list-column header="FÄRG" field="color"
      width="5%" [sortable]="true">
      <ng-template let-row="row">
        <div class="color-box" [ngStyle]="{'background-color': row.color}"></div>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="NAMN" field="namn" width="55%"
      [sortable]="true">
      <ng-template let-row="row">
        <a [routerLink]="['/transportforetag', row.id]">
          {{row.namn}}
        </a>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="HUVUDKOD" field="huvudkod"
    width="25%" [sortable]="true"></rask-list-column>
    <rask-list-column header="AKTIV" field="aktiv" width="5%">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
    <rask-list-column header="RUNDVIRKE" field="hasGeometryRundvirke"
      width="5%">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
    <rask-list-column header="BRÄNSLE" field="hasGeometryBransle"
      width="5%">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
  </rask-list>
</div>